import Knock from '@knocklabs/client'
import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { KNOCK_PUBLIC_KEY } from '@/constants/env'

import { useNotificationToken } from '@/hooks/notifications/useNotificationToken'

import type { NotificationPreferenceSet } from '@/notifications/types'

export const getNotificationPreferencesQueryKey = (userId?: string) => [
  userId,
  'notificationPreferences',
]

export const useNotificationPreferences = () => {
  const { user } = useAuthInfo()
  const { data: token } = useNotificationToken()

  const fetchPreferences =
    async (): Promise<NotificationPreferenceSet | null> => {
      if (!user || token === undefined) {
        return null
      }

      const knockClient = new Knock(KNOCK_PUBLIC_KEY)
      knockClient.authenticate(user.userId, token)
      const preferences = await knockClient.user.getPreferences()
      return preferences as NotificationPreferenceSet
    }

  return useQuery({
    queryFn: fetchPreferences,
    queryKey: getNotificationPreferencesQueryKey(user?.userId),
    enabled: !!user && token !== undefined,
    staleTime: Infinity,
  })
}
